import styled from 'styled-components';
import Colors from '@/constants/Colors';
export const StyledConceptOptions = styled.div`
  position: absolute;
  top: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  width: 100%;
  .answers {
    min-width: 40%;
    display: flex;
    flex-direction: column;
    gap: 0.5cqw;

    @media (orientation: portrait) {
      min-width: 60%;
    }
  }
`;
